// extracted by mini-css-extract-plugin
export default {"container":"describe-card_container__UWiDb","content":"describe-card_content__YQoPe"};